<template>
  <div class="bills">
    <!-- switch type search -->
    <v-container>
      <v-row>
        <v-switch
          v-model="showFilters"
          label="Mostrar filtros"
          class="mt-0 mb-3"
          color="secondary"
          hide-details
        ></v-switch>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab right color="secondary" small @click="reload">
          <v-icon> mdi-reload </v-icon>
        </v-btn>
        <v-btn
          class="mx-2"
          fab
          right
          color="secondary"
          small
          @click="donwloadReport"
          title="Descargar Base"
        >
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </v-row>
    </v-container>

    <!-- Filters text search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6" class="py-0">
            <v-text-field
              label="Filtre # de cuenta, por cedula o nombre del colaborador"
              outlined
              hide-details
              dense
              append-icon="mdi-magnify"
              v-model="searchInput"
              clearable
              clear-icon="mdi-close-circle"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="py-0">
            <v-btn block color="secondary" @click="searchText"> Buscar </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Filters date and options search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <VueCtkDateTimePicker
              color="DodgerBlue"
              v-model="datePiker.model"
              :label="datePiker.label"
              :range="true"
              :custom-shortcuts="datePiker.shortcut"
              :format="datePiker.format"
              :formatted="datePiker.formatted"
              inputSize="sm"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              outlined
              :items="this.$store.state.status.billStatus"
              label="Seleccione Estado"
              no-data-text="No hay registros..."
              hide-details
              dense
              v-model="filters.status"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="secondary" @click="searchFilters">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Table -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="this.$store.state.bill.bills.bills.data"
        :search="search"
        hide-default-footer
        :items-per-page="20"
        :loading="this.$store.state.bill.bills.isLoading"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.reference`]="item">
          <v-chip color="primary" small>
            {{ item.item.reference }}
          </v-chip>
        </template>
        <template v-slot:[`item.created_at`]="item">
          {{ item.item.created_at.substring(0, 10) }}
        </template>
        <template v-slot:[`item.value`]="item">
          {{ item.item.value | formatNumber }}
        </template>
        <template v-slot:[`item.referenceReport`]="item">
          {{ item.item.report ? item.item.report.reference : 'N/A' }}
        </template>
        <template v-slot:[`item.referenceContract`]="item">
          {{ item.item.contract.reference }}
        </template>
        <template v-slot:[`item.employee`]="item">
          {{ item.item.contract.employee.user.full_name }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip :color="getBillStatuColor(item.item.status)" dark small>
            {{ getBillStatus(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="show(item.item.id)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="open(item.item)"
                v-if="item.item.bill_url"
              >
                mdi-file-download
              </v-icon>
            </template>
            <span>Descargar Cuenta</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="upload(item.item)"
                target="_blank"
                v-if="
                  role == 'EMPLOYEE' &&
                  item.item.bill_url &&
                  !item.item.bill_signed_url
                "
              >
                mdi-file-upload
              </v-icon>
            </template>
            <span>Subir Cuenta Firmada</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus(item.item, 'CORRECTION')"
                target="_blank"
                v-if="
                  role == 'ADMINISTRATOR' &&
                  item.item.status == 'PENDING_APPROVAL'
                "
              >
                mdi-account-alert
              </v-icon>
            </template>
            <span>Corregir</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus(item.item, 'PENDING_PAYMENT')"
                target="_blank"
                v-if="
                  role == 'ADMINISTRATOR' &&
                  (item.item.status == 'PENDING_APPROVAL' ||
                    item.item.status == 'CORRECTION')
                "
              >
                mdi-checkbox-marked-circle
              </v-icon>
            </template>
            <span>Aprobar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus(item.item, 'PAID')"
                target="_blank"
                v-if="
                  role == 'ADMINISTRATOR' &&
                  item.item.status == 'PENDING_PAYMENT'
                "
              >
                mdi-cash-check
              </v-icon>
            </template>
            <span>Pagar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="role == 'ADMINISTRATOR'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                @click="distroy(item.item)"
                class="px-1"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <!-- Dialog upload bill signed -->
    <v-dialog v-model="dialogUpload" width="500" persistent>
      <v-card>
        <v-card-title v-if="currentBill">
          Subir Cuenta de Cobro Firmada - #{{ currentBill.reference }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpload" v-model="formUpload">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Cuenta de Cobro Firmada"
              v-model="model.bill_signed_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Seguridad Social"
              v-model="model.payroll_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelUpload">Cancelar</v-btn>
          <v-btn text color="primary" @click="saveUpload">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog change status -->
    <v-dialog v-model="dialogChangeStatus" width="500" persistent>
      <v-card>
        <v-card-title v-if="currentBill">
          <p class="text-center">
            Seguro que desea <b>{{ cardText }}</b> la cuenta de cobro - #{{
              currentBill.reference
            }}
          </p>
        </v-card-title>
        <v-card-text v-if="model.status == 'PAID'">
          <v-form ref="formUpload" v-model="formUpload">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Soporte de pago"
              v-model="model.support_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-text v-if="model.status == 'CORRECTION'">
          <v-textarea
            label="Nota o observación"
            v-model="model.note"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelChangeStatus">Cancelar</v-btn>
          <v-btn text color="primary" @click="changeStatusConfirmation"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea eliminar esta cuenta de cobro?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="distroyConfirmation"
            small
          >
            Confirmar
          </v-btn>

          <v-btn color="error" text class="mr-4" @click="closeDistroy" small>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loader -->
    <v-dialog v-model="this.$store.state.bill.bills.isLoadingReport" persistent width="300">
      <v-card color="primary" dark class="pt-4">
        <v-card-text class="font-weight-bold">
          {{ textLoader }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Excel -->
    <vue-excel-xlsx
      :data="excel.data"
      :columns="excel.columns"
      :filename="excel.filename"
      :sheetname="excel.sheetname"
      ref="exportExcel"
    >
    </vue-excel-xlsx>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BILLS } from "@/store/bill/bills";
import { SET_ALERT } from "@/store/alert";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  name: "Bills",
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  components: {
    VueCtkDateTimePicker,
  },
  data: () => ({
    search: "",
    showFilters: false,
    searchInput: "",
    formUpload: true,
    dialogDelete: false,
    dialogUpload: false,
    dialogChangeStatus: false,
    dialogLoader: false,
    textLoader: "Iniciando descarga, por favor espere...",
    headers: [
      {
        text: "# Cuenta",
        value: "reference",
        filterable: true,
        sortable: true,
      },
      {
        text: "Fecha",
        value: "created_at",
        filterable: true,
        sortable: true,
      },
      {
        text: "Valor",
        value: "value",
        filterable: true,
        sortable: true,
      },
      {
        text: "# Informe",
        value: "referenceReport",
        filterable: true,
        sortable: true,
      },
      {
        text: "# Contrato",
        value: "referenceContract",
        filterable: true,
        sortable: true,
      },
      {
        text: "Colaborador",
        value: "employee",
        filterable: true,
        sortable: true,
      },
      { text: "Estado", value: "status", filterable: true, sortable: false },
      { text: "Acciones", value: "actions", filterable: true, sortable: false },
    ],
    excel: {
      data: [],
      columns: [
        {
          label: "Colaborador",
          field: "employee",
        },
        {
          label: "# Documento",
          field: "colombianId",
        },
        {
          label: "Fecha Solicitud",
          field: "createdAt",
        },
        {
          label: "Valor",
          field: "value",
        },
        {
          label: "# CUENTA",
          field: "reference",
        },
        {
          label: "# REPORTE",
          field: "referenceReport",
        },
        {
          label: "# CONTRACTO",
          field: "referenceContract",
        },
        {
          label: "FECHA APROBACION",
          field: "approvalDate",
        },
        {
          label: "USUARIO QUE APROBO",
          field: "approvalBy",
        },
        {
          label: "FECHA DE PAGO",
          field: "paidDate",
        },
        {
          label: "USUARIO QUE PAGO",
          field: "paidBy",
        },
        {
          label: "ESTADO",
          field: "status",
        },
      ],
      filename:
        "Reporte_Cuentas_Cobro_" + new Date().toISOString().substr(0, 10),
      sheetname: "Cuentas de cobro " + new Date().toISOString().substr(0, 10),
    },
    filters: {
      status: "",
    },
    pagination: {
      current: 0,
      total: 0,
    },
    model: {
      bill_signed_file: null,
      status: "",
      support_file: null,
      payroll_file: null,
      note: "",
    },
    rules: {
      file: (value) => !value || "Documento obligatorio",
      max_file: (value) =>
        !value ||
        value.size < 20971520 ||
        "El documento debe pesar menos de 20MB",
    },
    currentBill: null,
    cardText: "",
    searchFiltersText: "",
  }),
  created() {
    this.$store.dispatch("getBills");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_BILLS) {
        this.pagination.current = state.bill.bills.bills.current_page;
        this.pagination.total = state.bill.bills.bills.last_page;
      }
    });
  },
  computed: {
    ...mapGetters(["getBillStatus", "getBillStatuColor"]),
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
    user() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user
        : "";
    },
    datePiker() {
      return this.$store.state.status.datePiker;
    },
  },
  methods: {
    show(id) {
      window.open(`/bills/show/${id}`, '_blank').focus();      
    },
    nextPage() {
      this.$store.dispatch("nextPageBills", this.pagination.current);
    },
    open(bill) {
      window.open(bill.bill_url, "_blank");
    },
    upload(bill) {
      this.currentBill = bill;
      this.dialogUpload = true;
    },
    cancelUpload() {
      this.currentBill = null;
      this.dialogUpload = false;
    },
    saveUpload() {
      if (
        this.model.bill_signed_file == null ||
        this.model.payroll_file == null
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar los archivos",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateBill", {
        id: this.currentBill.id,
        form: this.createFormData(),
      });
      this.cancelUpload();
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        }
      });
      return formData;
    },
    changeStatus(bill, status) {
      if (status == "PENDING_PAYMENT") {
        this.cardText = "APROBAR";
      } else if (status == "PENDING_APPROVAL") {
        this.cardText = "PAGAR";
      } else {
        this.cardText = "CORREGIR";
      }
      this.model.status = status;
      this.currentBill = bill;
      this.dialogChangeStatus = true;
    },
    cancelChangeStatus() {
      this.currentBill = null;
      this.cardText = "";
      this.model.support_file = null;
      this.dialogChangeStatus = false;
    },
    changeStatusConfirmation() {
      if (this.model.support_file == null && this.model.status == "PAID") {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar el soporte de pago",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateBill", {
        id: this.currentBill.id,
        form: this.createFormData(),
      });
      this.cancelChangeStatus();
    },
    reload() {
      this.searchInput = "";
      this.filters = {
        status: "",
      };
      this.datePiker.model = null;
      this.searchFiltersText = "";
      this.showFilters = false;
      this.$store.dispatch("getBills");
    },
    searchText() {
      if (this.searchLoanInput == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }
      this.showFilters = false;
      this.$store.dispatch("getBills", "search=" + this.searchInput + "&");
    },
    searchFilters() {
      this.searchFiltersText = "";

      if (this.datePiker.model !== null) {
        this.searchFiltersText =
          "min_date=" +
          this.datePiker.model.start +
          "&max_date=" +
          this.datePiker.model.end +
          "&";
      }

      if (this.filters.status !== "") {
        this.searchFiltersText += "status=" + this.filters.status + "&";
      }

      if (this.searchFiltersText == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }

      this.showFilters = false;
      this.$store.dispatch("getBills", this.searchFiltersText);
    },
    distroy(bill) {
      this.currentBill = bill;
      this.dialogDelete = true;
    },
    distroyConfirmation() {
      this.$store.dispatch("deleteBill", this.currentBill.id);
      this.closeDistroy();
    },
    closeDistroy() {
      this.currentBill = null;
      this.dialogDelete = false;
    },
    async donwloadReport() {      
      try {
        if (this.searchFiltersText == "") {
          this.$store.commit(SET_ALERT, {
            message: "Ingrese un valor de busqueda",
            type: "info",
          });
          return;
        }

        await this.$store
          .dispatch("getBillsAll", this.searchFiltersText)
          .then((data) => {
            data.forEach((item) => {
              this.excel.data.push({
                employee: item.contract.employee.user.full_name,
                colombianId: item.contract.employee.user.colombian_id,
                createdAt: item.created_at.substring(10, 0),
                value: item.value,
                reference: item.reference,                
                referenceReport: item.report ? item.report.reference : "N/A",
                referenceContract: item.contract.reference,
                approvalDate: item.approval_date,
                approvalBy: item.approval_by ? item.approval_by.full_name : '',
                paidDate: item.paid_date,
                paidBy: item.paid_by ? item.paid_by.full_name : '',
                status: this.getBillStatus(item.status),
              });
            });
          });
               
        //Trigger event click for export excel
        this.$refs.exportExcel.$el.click();
      } catch (error){
        console.error(error);
        this.$store.commit(SET_ALERT, {
          message: "Error al descargar el reporte",
          type: "error",
        });
      } 
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
